<template>
  <div
    :class="{ 'non-pda-item': !isPda, 'pda-item': isPda && !(!item.available || !isCategoryOpen), 'pt-0': isPda && item.available && index==0, disabled: !item.available || !isCategoryOpen, 'button-look': isPda && $screen.width > 1018 && !(!item.available || !isCategoryOpen), 'pop-up': clicked  }"
    @click="onAddItem"
    id="menu-item"
  >
    <div
      id="title-n-description"
      :class="{ smallerWidth: item.photoLink != undefined && item.photoLink != null && item.photoLink != '' && !hideImage }"
    >
      <div :class="{ crossOut: !item.available || !isCategoryOpen }">
        <h3
          class="menu-item-title"
          :class="{'margin-bottom-8': !item.priceable, 'menu-item-smaller-title': isPda && $screen.width > 1018 && $screen.width < 1397}"
          :style="isPda && item.textColor!=null && ($screen.width > 1018 || ($screen.width <= 1018 && applyColorsAlsoToMobileScreens)) ? { color: '#f7f7f7'} : {}"
        >{{getItemName(item)}}</h3>
      </div>
      <div
        :class="{
          'no-image-description-width':
            hideImage || item.photoLink == undefined,
          'margin-bottom-1': item.priceable
        }"
        id="description"
      >
        <v-clamp
          v-if=" !hideDescription && ((item.names && item.names.translation[language].details!=null && item.names.translation[language].details.trim().length!=0) || (selectedExtraLanguage!=null && item.names && item.names.translation[selectedExtraLanguage] && item.names.translation[selectedExtraLanguage].details!=null && item.names.translation[selectedExtraLanguage].details.trim().length!=0))"
          :max-lines="2"
          :style="isPda && item.textColor!=null && ($screen.width > 1018 || ($screen.width <= 1018 && applyColorsAlsoToMobileScreens)) ? { color: '#f7f7f7'} : {}"
        >{{getItemDetails(item)}}</v-clamp>
      </div>
      <div id="price-container" v-if="item.priceable">
        <h3
          class="regular-price"
          :class="{'regular-smaller-price': isPda && $screen.width > 1018 && $screen.width < 1397, 'flex-display': item.glutenFree}"
          :style="isPda && item.textColor!=null && ($screen.width > 1018 || ($screen.width <= 1018 && applyColorsAlsoToMobileScreens)) ? { color: '#f7f7f7'} : {}"
        >
          <span
            v-if="userHasMembership && itemHasMemberShipPrice"
            class="crossOut"
            style="color: #808080; font-style: italic"
            :class="{'mr-1': item.glutenFree}"
          >{{cost}}</span>
          {{ userHasMembership && itemHasMemberShipPrice ? membershipCost : cost }}€{{item.perKg ? ' / kg' : ''}}
          <font-awesome-icon
            v-if="membershipInfoShown && (itemHasMembershipPriceHidden || (userHasMembership && itemHasMemberShipPrice))"
            icon="home"
            style="margin-left: 4px; color: #737373;"
          />

          <span v-if="item.vegetarian" class="vegan-title">Vegetarian</span>
          <font-awesome-icon v-if="item.vegetarian" icon="seedling" style="color: #198b4a;" />

          <span v-if="item.vegan" class="vegan-title">Vegan</span>
          <font-awesome-icon v-if="item.vegan" icon="leaf" style="color: #198b4a;" />

          <span v-if="item.glutenFree" class="vegan-title">Gluten Free</span>
          <img v-if="item.glutenFree" src="../assets/food-no-gluten.svg" width="22px" alt />
        </h3>
      </div>
      <div id="price-container" v-else-if="item.vegetarian || item.vegan || item.glutenFree">
        <h3
          class="regular-price"
          :class="{'regular-smaller-price': isPda && $screen.width > 1018 && $screen.width < 1397, 'flex-display': item.glutenFree}"
        >
          <span v-if="item.vegetarian" class="vegan-title">Vegetarian</span>
          <font-awesome-icon v-if="item.vegetarian" icon="seedling" style="color: #198b4a;" />

          <span v-if="item.vegan" class="vegan-title">Vegan</span>
          <font-awesome-icon v-if="item.vegan" icon="leaf" style="color: #198b4a;" />

          <span v-if="item.glutenFree" class="vegan-title">Gluten Free</span>
          <img v-if="item.glutenFree" src="../assets/food-no-gluten.svg" width="22px" alt />
        </h3>
      </div>

      <div
        v-if="membershipInfoShown && shouldShowMembershipPrice && item.priceable"
        id="membership-price-container"
      >
        <h3
          class="membership-price"
          v-if="storeIsHotel"
        >{{ labels.menu.allInclusivePrice[language] + membershipCost }}€</h3>
        <h3
          class="membership-price"
          v-if="!storeIsHotel"
        >{{ labels.menu.memberShipPrice[language] + membershipCost }}€</h3>
        <h3
          v-if="!storeIsHotel"
          class="membership-price"
          style="padding-top: 1px"
        >{{ labels.menu.onlyForFluterOrders[language]}}</h3>
        <h3
          v-if="!storeIsHotel"
          class="membership-price"
          style="padding-top: 1px"
        >{{ labels.menu.askStoreForMembershipInfo[language]}}</h3>
      </div>
    </div>
    <div
      v-if="item.photoLink != undefined && item.photoLink != null && item.photoLink != '' && !hideImage && !hidePhotos"
      class="image-container"
    >
      <img
        v-if="item.photoLink != undefined && item.photoLink != null && item.photoLink.trim().length!=0 && item.photoLink.endsWith('.gif')"
        class="item-img"
        :src="`${item.photoLink}`"
      />
      <vue-load-image
        v-else-if="item.photoLink != undefined & item.photoLink != null && item.photoLink.trim().length!=0 && !item.photoLink.endsWith('.gif')"
      >
        <img slot="image" :src="`${item.photoLink}`" class="item-img" />
        <img slot="preloader" src="../assets/images/loading_img.gif" class="item-img" />
      </vue-load-image>
      <button
        v-if="isInteractiveCatalogue && !(isPda && $screen.width > 1018)"
        class="bottom-right-to-img-plus plus-btn-to-cart"
        type="button"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          class
          width="100%"
          height="100%"
        >
          <path
            fill="currentColor"
            d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
          />
        </svg>
      </button>
    </div>
    <div
      v-else-if="isInteractiveCatalogue && !(isPda && $screen.width > 1018)"
      class="image-plus-container"
    >
      <button class="center-to-item-plus plus-btn-to-cart" type="button">
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
          class
          width="100%"
          height="100%"
        >
          <path
            fill="currentColor"
            d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>


<script>
import VClamp from "vue-clamp";
import VueLoadImage from 'vue-load-image';

export default {
  name: "MenuItem",
  components: {
    VClamp,
    'vue-load-image': VueLoadImage
  },
  computed: {
    cost() {
      let firstAggregatedSubCategory = this.item.subselections.find(subselection => subselection.priceAggregated);
      if (firstAggregatedSubCategory) {
        return (firstAggregatedSubCategory.options[0].price + this.item.price).toFixed(2);
      } else {
        return this.item.price.toFixed(2);
      }

    },

    membershipCost() {
      return this.item.membershipPrice.toFixed(2);
    },

    itemHasMemberShipPrice() {
      return this.membershipEnabledForRestaurant && this.item.memberPriceEnabled && this.item.price != this.item.membershipPrice
    },

    //we show the extra membership price only to the non member users
    //the member users when they log in they see as the regular price the membership price 
    shouldShowMembershipPrice() {
      return this.membershipEnabledForRestaurant && this.membershipPricesVisible && this.item.memberPriceEnabled && this.item.price != this.item.membershipPrice && !this.userHasMembership;
    },

    itemHasMembershipPriceHidden() {
      return this.membershipEnabledForRestaurant && !this.membershipPricesVisible && this.item.memberPriceEnabled && this.item.price != this.item.membershipPrice;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    selectedExtraLanguage() {
      return this.$store.getters.getSelectedExtraLanguage;
    },
  },
  props: ["item", "index", "autoAddInCartItemsWithoutSubs", "autoAddInCartAllItems", "autoAddInCartItemsWithoutSubsAtMobile", "autoAddInCartAllItemsAtMobile", "membershipEnabledForRestaurant", "membershipInfoShown", "membershipPricesVisible", "userHasMembership", "storeIsHotel", "isCategoryOpen", "happyHourDiscountPercentage", "isInteractiveCatalogue", "hideDescription", "hidePhotos", "isPda", "applyColorsAlsoToMobileScreens"],
  data() {
    return {
      hideImage: false,
      clicked: false,
      pressTimerTimeout: null,
      isLongPress: false,
    };
  },
  methods: {
    getItemName(item) {
      if (this.selectedExtraLanguage != null && item.names.translation[this.selectedExtraLanguage] && item.names.translation[this.selectedExtraLanguage].name != null && item.names.translation[this.selectedExtraLanguage].name.trim().length != 0) {
        return item.names.translation[this.selectedExtraLanguage].name;
      }
      return item.names.translation[this.language].name;
    },
    getItemDetails(item) {
      if (this.selectedExtraLanguage != null && item.names.translation[this.selectedExtraLanguage] && item.names.translation[this.selectedExtraLanguage].details != null && item.names.translation[this.selectedExtraLanguage].details.trim().length != 0) {
        return item.names.translation[this.selectedExtraLanguage].details;
      }
      return item.names.translation[this.language].details;
    },

    // TODO consume this method and make it to pop up modal after some seconds else add item
    // use mouseDown, mouseUp, mouseLeave, touchstart, touchend events
    startPress() {
      this.isLongPress = false;
      let autoAddItemsWithoutSubs = this.isPda && ((this.autoAddInCartItemsWithoutSubs && this.$screen.width > 1018) || (this.autoAddInCartItemsWithoutSubsAtMobile && this.$screen.width <= 1018)) && !this.item.perKg && (this.item.subselections == null || this.item.subselections.length == 0);
      let autoAddAllItems = this.isPda && ((this.autoAddInCartAllItems && this.$screen.width > 1018) || (this.autoAddInCartAllItemsAtMobile && this.$screen.width <= 1018)) && !this.item.perKg;
      if (this.item.available && this.isCategoryOpen && (autoAddItemsWithoutSubs || autoAddAllItems)) {
        this.pressTimerTimeout = setTimeout(() => {
          this.isLongPress = true;
          this.showAddItemModal();
        }, 600);
      }
    },

    // TODO consume this method and make it to pop up modal after some seconds else add item
    // use mouseDown, mouseUp, mouseLeave, touchstart, touchend events
    endPress() {
      clearTimeout(this.pressTimerTimeout);
      if (!this.isLongPress) {
        this.onAddItem();
      }
    },

    // TODO consume this method and make it to pop up modal after some seconds else add item
    // use mouseDown, mouseUp, mouseLeave, touchstart, touchend events
    cancelPress() {
      clearTimeout(this.pressTimerTimeout);
    },

    onAddItem: async function () {

      if (this.item.available && this.isCategoryOpen) {

        if (this.isPda && this.item.openPrice) {
          this.showAddItemModal();
          return;
        }

        if (this.isPda && ((this.autoAddInCartItemsWithoutSubs && this.$screen.width > 1018) || (this.autoAddInCartItemsWithoutSubsAtMobile && this.$screen.width <= 1018)) && !this.item.perKg && (this.item.subselections == null || this.item.subselections.length == 0)) {

          if (this.item.stockEnabled && this.item.stockAmount == 0) {
            this.$confirm({
              message: `Απομένουν 0 τεμάχια για ${this.item.names.translation.GRE.name}. Δεν μπορείτε να το προσθέσετε στο καλάθι.`,
              button: {
                yes: 'ΟΚ'
              },
              callback: async confirm => {
                if (confirm) {
                } else {
                }
              }
            });
            return;
          }

          let item = { ...this.item };

          let nextItemId = this.$store.getters.getNextItemId;
          let storeId = this.$store.getters.getStoreId;
          let serviceId = this.$store.getters.getServiceId;

          this.clicked = true;
          this.$store.dispatch("addToCart", {
            storeId: storeId,
            serviceId: serviceId,
            item: item,
            quantity: 1,
            kilos: 0,
            comment: "",
            id: nextItemId,
          });

          this.$store.dispatch("incrementNextItemId");
          this.$store.dispatch("itemHasBeenInserted");

          if (this.$screen.width > 1018 && this.autoAddInCartItemsWithoutSubs) {
            setTimeout(() => {
              try {
                let cartSummaryPdaDesktop = document.getElementById("pda-cart-summary");
                if (cartSummaryPdaDesktop != null) {
                  cartSummaryPdaDesktop.scrollTop = cartSummaryPdaDesktop.scrollHeight;
                }
              } catch (error) {
                console.log("Could not scroll to bottom of cart summary")
              }
            }, 80);
          } else if (this.$screen.width <= 1018 && this.autoAddInCartItemsWithoutSubsAtMobile) {
            let itemName = this.getItemName(this.item);
            this.$emit("show-top-notification", `1x ${itemName}`);
          }

          setTimeout(() => {
            this.clicked = false;
          }, 95);

        } else if (this.isPda && ((this.autoAddInCartAllItems && this.$screen.width > 1018) || (this.autoAddInCartAllItemsAtMobile && this.$screen.width <= 1018)) && !this.item.perKg) {

          if (this.item.stockEnabled && this.item.stockAmount == 0) {
            this.$confirm({
              message: `Απομένουν 0 τεμάχια για ${this.item.names.translation.GRE.name}. Δεν μπορείτε να το προσθέσετε στο καλάθι.`,
              button: {
                yes: 'ΟΚ'
              },
              callback: async confirm => {
                if (confirm) {
                } else {
                }
              }
            });
            return;
          }

          let item = null;
          if (this.item.subselections == null || this.item.subselections.length == 0) {
            item = { ...this.item };
          } else if (this.item.subselections != null && this.item.subselections.length > 0) {
            item = JSON.parse(JSON.stringify(this.item));

            item.subselections.forEach(subselection => {
              subselection.options.forEach(option => {
                if (option.defaultSelected) {
                  option.isSelected = true;
                } else {
                  option.isSelected = false;
                }
              });

              if (subselection.mandatory) {
                subselection.options[0].isSelected = true;
              }
            })
          } else {
            item = { ...this.item };
          }

          let nextItemId = this.$store.getters.getNextItemId;
          let storeId = this.$store.getters.getStoreId;
          let serviceId = this.$store.getters.getServiceId;

          this.clicked = true;
          this.$store.dispatch("addToCart", {
            storeId: storeId,
            serviceId: serviceId,
            item: item,
            quantity: 1,
            kilos: 0,
            comment: "",
            id: nextItemId,
          });

          this.$store.dispatch("incrementNextItemId");
          this.$store.dispatch("itemHasBeenInserted");

          if (this.$screen.width > 1018 && this.autoAddInCartAllItems) {
            setTimeout(() => {
              try {
                let cartSummaryPdaDesktop = document.getElementById("pda-cart-summary");
                if (cartSummaryPdaDesktop != null) {
                  cartSummaryPdaDesktop.scrollTop = cartSummaryPdaDesktop.scrollHeight;
                }
              } catch (error) {
                console.log("Could not scroll to bottom of cart summary")
              }
            }, 80);
          } else if (this.$screen.width <= 1018 && this.autoAddInCartAllItemsAtMobile) {
            let itemName = this.getItemName(this.item);
            this.$emit("show-top-notification", `1x ${itemName}`);
          }


          setTimeout(() => {
            this.clicked = false;
          }, 95);

        } else {
          this.showAddItemModal();
        }
      }
    },

    showAddItemModal() {
      let item = JSON.parse(JSON.stringify(this.item))

      item.subselections.forEach(subselection => {
        subselection.options.forEach(option => {
          if (option.defaultSelected) {
            option.isSelected = true;
          } else {
            option.isSelected = false
          }
        })
        if (subselection.mandatory) {
          subselection.options[0].isSelected = true;
        }
      })

      this.$store.dispatch("setSelectedItem", item);
      this.$store.dispatch("setItemModalTrigger", "MenuItem");

      let modal = document.getElementById("modal");
      if (modal != null) {
        modal.scrollTop = 0;
      }

      this.$store.dispatch("openItemModal");
    },

    showNoImage: function () {
      this.hideImage = true;
    },
  },
};
</script>

<style scoped>
#menu-item {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 2% 0 2% 0;
  cursor: pointer;
  z-index: 1;
}

.button-look {
  background-color: #efefef;
  box-shadow: 1px 1px 4px rgb(117, 117, 117);
  border-radius: 10px;
  padding-left: 6px;
  padding-right: 2px;
  padding-top: 2px;
  padding-bottom: 2px;
}

#title-n-description {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-weight: 500;
  margin-top: 1vh;
}

.smallerWidth {
  width: 75%;
}

.pop-up {
  box-shadow: 0 0 10px 1px #000000;
  z-index: 200 !important;
  transform: scale(1.03);
  border-radius: 7px !important;
}

@media screen and (max-width: 1018px) {
  #title-n-description {
    padding-right: 0px;
    padding-left: 0px;
    margin-top: 2px;
  }
}

.menu-item-title {
  font-family: "Fluter-font-bold" !important;
  color: #141414;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 4px;
  word-break: break-word;
}

.menu-item-smaller-title {
  font-size: 14px !important;
  font-weight: 600 !important;
}

#description {
  font-family: "Fluter-font" !important;
  color: rgb(112, 112, 112);
  font-size: 14px;
  font-weight: 500;
  padding-right: 8%;
  white-space: pre-wrap;
  word-break: break-word;
}

.no-image-description-width {
  padding-right: 0 !important;
}
.margin-bottom-1 {
  margin-bottom: 1px;
}

.margin-bottom-8 {
  margin-bottom: 8px !important;
}

.vegan-title {
  margin-left: 4px;
  margin-right: 4px;
  color: #707070;
  white-space: nowrap;
}

#price-container {
  font-family: "Fluter-font" !important;
  display: flex;
  color: rgb(20, 20, 20);
}

#membership-price-container {
  font-family: "Fluter-font" !important;
  display: flex;
  flex-direction: column;
}

.regular-price {
  font-size: 14px;
  font-weight: 500;
  padding-top: 4%;
  margin: 0 10px 0 0;
}

.regular-smaller-price {
  font-size: 12px;
  font-weight: 500;
  padding-top: 0%;
}

.flex-display {
  display: flex;
  align-items: center;
  padding-top: 2px !important;
}

.mr-1 {
  margin-right: 4px;
}

.membership-price {
  color: #188e4b;
  font-size: 14px;
  font-weight: 500;
  padding-top: 3%;
  margin: 0 10px 0 0;
  font-style: italic;
}

.discounted {
  color: #198b4a !important;
  font-weight: 700 !important;
}

.image-container {
  position: relative;
  margin: 0px 0px 0px 0px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  width: 112px;
  height: 98px;
}

.image-plus-container {
  position: relative;
  margin: 0px 0px 0px 0px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  width: 30px;
  height: 30px;
}

.item-img {
  width: 112px;
  aspect-ratio: auto 112 / 98;
  height: 98px;
  box-sizing: border-box;
  object-fit: cover;
  object-position: center center;
  z-index: 0;
  margin: 0px auto;
  border-radius: 8px;
  max-width: 100%;
}

.bottom-right-to-img-plus {
  position: absolute;
  z-index: 1;
  right: -0.4rem;
  bottom: -0.5rem;
}

.center-to-item-plus {
  position: absolute;
  right: -0.4rem;
  z-index: 1;
}

.plus-btn-to-cart {
  width: 2rem;
  height: 2rem;
  padding: 0.5rem;
  color: rgb(114, 114, 114);
  background-color: rgb(243, 243, 243);
  border: rgb(243, 243, 243);

  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border-radius: 8px;
}

.crossOut {
  text-decoration: line-through;
}

.crossOut > h3 {
  color: gray !important;
}

.disabled {
  cursor: not-allowed !important;
  background-color: rgba(180, 180, 180, 0.2);
  padding: 5px;
  border-radius: 10px;
  min-height: 80%;
  width: 101% !important;
}

.grayOut {
  filter: grayscale(75%);
}

/* responsive shit */

@media screen and (max-width: 1018px) {
  .non-pda-item {
    margin: 4% 0 4% 0 !important;
  }

  .pda-item {
    padding: 3.7% 0 3.7% 0;
    margin: 0px 0px 0px 0px !important;
  }

  .menu-item-title {
    padding-right: 5px;
  }

  #name-and-description {
    padding-right: 5%;
  }
}

@media screen and (max-width: 753px) {
  .menu-item-title {
    font-size: 0.94rem;
  }

  #description {
    font-size: 0.868rem;
  }

  .regular-price {
    font-size: 0.88rem;
  }

  .membership-price {
    font-size: 0.88rem;
  }
}

@media screen and (max-width: 640px) {
  .pt-0 {
    padding-top: 0px !important;
  }
}
</style>
7